module.exports = __webpack_public_path__ + "img/flag-th.3812ba09.svg";